module.exports = __webpack_public_path__ + "media/images/disc_band_icon-9e72b173.svg";